/**
 * Entity Role/Class Definitions
 * Shared between server and client for role-based access control
 */

export const EntityClasses = Object.freeze({
  admin_root_role: {
    value: 100,
    desc: "Administrator superuser infrastructure architecture"
  },
  admin_business_role: {
    value: 90,
    desc: "Administrator financial oversight"
  },
  admin_support_role: {
    value: 80,
    desc: "Administrator maintenance and configuration"
  },
  admin_readonly_role: {
    value: 70,
    desc: "Administrator information help desk"
  },
  client_tier_3_role: {
    value: 30,
    desc: "Client paid tier 3"
  },
  client_tier_2_role: {
    value: 20,
    desc: "Client paid tier 2"
  },
  client_tier_1_role: {
    value: 10,
    desc: "Client paid tier 1"
  },
  client_standard_role: {
    value: 0,
    desc: "Client free tier 0"
  }
});

/**
 * Get role by name
 */
export function getRoleByName(name) {
  return EntityClasses[name] || null;
}

/**
 * Get role by value
 */
export function getRoleByValue(value) {
  return Object.entries(EntityClasses).find(([_, role]) => role.value === value)?.[1] || null;
}

/**
 * Check if user can assign target role
 */
export function canAssignRole(currentUserRoleValue, targetRoleValue) {
  return targetRoleValue <= currentUserRoleValue;
}

/**
 * Get roles sorted by privilege (highest first)
 */
export function getRolesSorted() {
  return Object.entries(EntityClasses)
    .map(([name, data]) => ({ name, ...data }))
    .sort((a, b) => b.value - a.value);
}

/**
 * Get roles user can assign (their level or lower)
 */
export function getAssignableRoles(currentUserRoleValue) {
  return getRolesSorted().filter(role => role.value <= currentUserRoleValue);
}

/**
 * Check if role is admin level (>= 50)
 */
export function isAdminRole(roleValue) {
  return roleValue >= 50;
}

/**
 * Check if role is client level (< 50)
 */
export function isClientRole(roleValue) {
  return roleValue < 50;
}
